import { useEffect } from 'react';
import { fixLocalDate } from '../utils/dateHelpers';

function useDefaultDate(setSelectedDates) {
  useEffect(() => {
    const today = new Date();
    const dayOfWeek = today.getDay();

    let targetDate;

    if (dayOfWeek === 0 || dayOfWeek === 6) {
      const daysToMonday = dayOfWeek === 0 ? 1 : 2;
      targetDate = new Date(today);
      targetDate.setDate(today.getDate() + daysToMonday);
    } else {
      targetDate = today;
    }

    setSelectedDates([fixLocalDate(targetDate)]);
  }, [setSelectedDates]);
}

export default useDefaultDate;
